module.exports = __webpack_public_path__ + "5999-shadow.3b483138c78cc2c7e7c0e9a95066551d.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/5999-shadow.png
// module id = 485
// module chunks = 0